<template>
  <BDLayout>
    <div class="transaction">
      <section id="bd-opportunity-create">
        <div class="container">
          <h6 class="fw-bold mb-2">New Opportunity</h6>
          <div class="">
            <div class="">
              <form @submit.prevent="saveOpportunity">
                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group mb-2">
                      <label>Tender Reference No</label>
                      <input v-model="form.tenderRefNo" type="text" class="form-control mb-4" required />
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group mb-2">
                      <label>Tender Title</label>
                      <input v-model="form.title" type="text" class="form-control mb-4" required />
                    </div>
                  </div>

                  <div class="col-md-4">
                    <div class="form-group mb-2">
                      <label>Client</label>
                      <select v-model="form.clientId" class="form-control mb-4" required>
                        <option value="">Select Client</option>
                        <option
                          v-for="c in clients"
                          :key="c.id"
                          :value="c.id"
                        >
                          {{ c.name }} ({{ c.country }})
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group mb-2">
                      <label>Country</label>
                      <select v-model="form.country" class="form-control mb-4">
                        <option value="">Select Country</option>
                        <option
                          v-for="c in countries"
                          :key="c.id || c.name"
                          :value="c.name"
                        >
                          {{ c.name }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group mb-2">
                      <label>Department</label>
                      <select v-model.number="form.departmentId" class="form-control mb-4">
                        <option value="">Select Department</option>
                        <option v-for="d in departments" :key="d.id" :value="d.id">
                          {{ d.name }}
                        </option>
                      </select>
                    </div>
                  </div>

                  <div class="col-md-4">
                    <div class="form-group mb-2">
                      <label>Sector</label>
                      <select v-model="form.sectorId" class="form-control mb-4">
                        <option value="">Select Sector</option>
                        <option
                          v-for="s in sectors"
                          :key="s.id || s.name"
                          :value="s.id"
                        >
                          {{ s.name }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group mb-2">
                      <label>Tender Type</label>
                      <select v-model="form.tenderTypeId" class="form-control mb-4">
                        <option value="">Select Tender Type</option>
                        <option
                          v-for="t in tenderTypes"
                          :key="t.id"
                          :value="t.id"
                        >
                          {{ t.name }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group mb-2">
                      <label>Estimated Value</label>
                      <input v-model.number="form.estimatedValue" type="number" class="form-control mb-4" />
                    </div>
                  </div>

                  <div class="col-md-4">
                    <div class="form-group mb-2">
                      <label>Pre-Bid Meeting</label>
                      <input v-model="form.preBidMeeting" type="date" class="form-control mb-4" />
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group mb-2">
                      <label>Site Visit</label>
                      <input v-model="form.siteVisit" type="date" class="form-control mb-4" />
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group mb-2">
                      <label>Clarification Deadline</label>
                      <input v-model="form.clarificationDeadline" type="date" class="form-control mb-4" />
                    </div>
                  </div>

                  <div class="col-md-4">
                    <div class="form-group mb-2">
                      <label>Source</label>
                      <input v-model="form.source" type="text" class="form-control mb-4" />
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group mb-2">
                      <label>Submission Deadline</label>
                      <input v-model="form.submissionDeadline" type="datetime-local" class="form-control mb-4" />
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group mb-2">
                      <label>Bid Security Required</label>
                      <select v-model="form.bidSecurityRequired" class="form-control mb-4">
                        <option :value="true">Yes</option>
                        <option :value="false">No</option>
                      </select>
                    </div>
                  </div>
                </div>

                <div class="d-flex justify-content-end mt-3" style="gap: 8px;">
                  <button type="button" class="btn btn-light" @click="$router.back()">Cancel</button>
                  <button type="submit" class="btn btn-primary" :disabled="saving">
                    <span v-if="!saving">Save &amp; Under Review</span>
                    <span v-else>Saving...</span>
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>
    </div>
  </BDLayout>
</template>

<script>
import { reactive, ref, computed, onMounted, watch } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import BDLayout from '@/components/BDLayout.vue'
import { bidApi } from '@/api/bid'

export default {
  name: 'BidOpportunityCreate',
  components: { BDLayout },
  setup() {
    const router = useRouter()
    const store = useStore()
    const saving = ref(false)
    const countries = ref([])
    const sectors = ref([])
    const tenderTypes = ref([])
    const form = reactive({
      tenderRefNo: '',
      title: '',
      clientId: '',
      country: '',
      departmentId: null,
      sectorId: '',
      tenderType: '',
      tenderTypeId: '',
      preBidMeeting: '',
      siteVisit: '',
      clarificationDeadline: '',
      estimatedValue: null,
      source: '',
      submissionDeadline: '',
      bidSecurityRequired: false,
      status: 'UNDER_REVIEW',
    })

    const departments = computed(() => store.getters.getDepartments || [])
    const clients = ref([])

    const loadCountries = async () => {
      try {
        const base = (process.env.VUE_APP_URL || 'http://localhost:3000').replace(/\/+$/, '')
        const res = await fetch(base + '/countries', {
          headers: {
            Accept: 'application/json',
            ...(localStorage.getItem('access_token')
              ? { Authorization: `Bearer ${JSON.parse(localStorage.getItem('access_token'))}` }
              : {}),
          },
        })
        if (!res.ok) return
        const data = await res.json()
        const list = data && typeof data === 'object' && (data.data || data.items || data.rows)
          ? data.data || data.items || data.rows
          : data
        countries.value = Array.isArray(list) ? list : []
      } catch (err) {
        console.error('Failed to load countries', err)
      }
    }

    const loadSectors = async () => {
      try {
        const base = (process.env.VUE_APP_URL || 'http://localhost:3000').replace(/\/+$/, '')
        const res = await fetch(base + '/sectors', {
          headers: {
            Accept: 'application/json',
            ...(localStorage.getItem('access_token')
              ? { Authorization: `Bearer ${JSON.parse(localStorage.getItem('access_token'))}` }
              : {}),
          },
        })
        if (!res.ok) return
        const data = await res.json()
        const list = data && typeof data === 'object' && (data.data || data.items || data.rows)
          ? data.data || data.items || data.rows
          : data
        sectors.value = Array.isArray(list) ? list : []
      } catch (err) {
        console.error('Failed to load sectors', err)
      }
    }

    const loadTenderTypes = async () => {
      try {
        const base = (process.env.VUE_APP_URL || 'http://localhost:3000').replace(/\/+$/, '')
        const res = await fetch(base + '/tender-type', {
          headers: {
            Accept: 'application/json',
            ...(localStorage.getItem('access_token')
              ? { Authorization: `Bearer ${JSON.parse(localStorage.getItem('access_token'))}` }
              : {}),
          },
        })
        if (!res.ok) return
        const data = await res.json()
        const list = data && typeof data === 'object' && (data.data || data.items || data.rows)
          ? data.data || data.items || data.rows
          : data
        tenderTypes.value = Array.isArray(list) ? list : []
      } catch (err) {
        console.error('Failed to load tender types', err)
      }
    }

    onMounted(async () => {
      if (!departments.value || !departments.value.length) {
        store.dispatch('fetchDepartments')
      }

      try {
        clients.value = await bidApi.listClients()
      } catch (err) {
        console.error('Failed to load clients', err)
      }

      await loadCountries()
      await loadSectors()
      await loadTenderTypes()
    })

    watch(
      () => form.clientId,
      (newClientId) => {
        if (!newClientId) return
        const selected = clients.value.find((c) => String(c.id) === String(newClientId))
        if (selected && selected.country) {
          form.country = selected.country
        }
        if (selected && (selected.sector?.id || selected.sectorId)) {
          form.sectorId = selected.sector?.id || selected.sectorId
        }
      },
    )

    const saveOpportunity = async () => {
      saving.value = true
      try {
        const payload = { ...form }
        if (form.tenderTypeId && !form.tenderType) {
          const selected = tenderTypes.value.find((t) => t.id === form.tenderTypeId)
          if (selected) {
            payload.tenderType = selected.name
          }
        }
        const res = await bidApi.createOpportunity(payload)
        const created = res && res.data ? res.data : res
        if (created && created.id) {
          router.push({ name: 'BidOpportunityDetail', params: { id: created.id } })
        } else {
          router.push({ name: 'BidOpportunitiesList' })
        }
      } catch (err) {
        console.error('Failed to create opportunity', err)
      } finally {
        saving.value = false
      }
    }

    return {
      form,
      clients,
      saving,
      departments,
      tenderTypes,
      countries,
      sectors,
      saveOpportunity,
    }
  },
}
</script>

<style scoped>
.card {
  border-radius: 8px;
}
</style>
